import "./App.css";
import CC from "./components/CC";

function App() {
  return (
    <div className="App">
      <CC />
    </div>
  );
}

export default App;
